import { render, staticRenderFns } from "./m-editCategorySNPMB.vue?vue&type=template&id=7dad3c4f&"
import script from "./m-editCategorySNPMB.vue?vue&type=script&lang=js&"
export * from "./m-editCategorySNPMB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports